/**
 * Structural check for the generated api-client's ResponseError. Shared code cannot import a
 * generated client (each app owns its own — see auth/authMiddleware.ts), and the two apps'
 * ResponseError classes are distinct types, so `instanceof` is not available here. Both generated
 * runtimes set `name = "ResponseError"` and carry the failed `Response`, which is all shared code
 * needs to branch on HTTP status.
 */
export function isResponseError(error: unknown): error is Error & { response: Response } {
  return error instanceof Error && error.name === "ResponseError" && "response" in error;
}
